// extracted by mini-css-extract-plugin
module.exports = {"root":"_39TcR","animator":"_33lvm","notification-link":"_1MnWU","notificationLink":"_1MnWU"};